import Debug   from './theme/debug.js';
import Helpers from './theme/helpers.js';

import Fix100vh from './theme/components/fix100vh.js';

import Hamburger from './theme/components/hamburger.js';
import AnimatedScroll from './theme/components/animated-scroll.js';
import Viewport from './theme/components/viewport.js';
import Parallax from './theme/components/parallax.js';
import Select from './theme/components/select.js';
import DateRangePicker from './theme/components/date-range-picker.js';
import ResponsiveBackgroundImage from './theme/components/responsive-background-image.js';
import Slideshow from './theme/components/slideshow.js';

import Hero from './theme/components/hero.js';
import VideoBackground from './theme/components/video-background.js';
import Blocks from './theme/components/blocks.js';
import Tabs from './theme/components/tabs.js';
import Gallery from './theme/components/gallery.js';
import Map from './theme/components/map.js';

import Pricelist from './theme/components/pricelist.js';
import Floorplan from './theme/components/floorplan.js';

window.theme = {
    globals: {
        enablePjax: true,
        isTouch: typeof window !== "undefined" && "ontouchstart" in window
    },
    init: function() {
        var theme = this;

        //Fixes
        theme.fix100vh = new Fix100vh();

        //Global
        theme.hamburger = new Hamburger();
        theme.animatedScroll = new AnimatedScroll();;
        theme.viewport = new Viewport();
        theme.parallax = new Parallax();
        theme.select = new Select();
        theme.dateRangePicker = new DateRangePicker();
        theme.responsiveBackgroundImage = new ResponsiveBackgroundImage();
        theme.slideshow = new Slideshow();

        //Page specific
        theme.hero = new Hero();
        theme.videoBackground = new VideoBackground();

        theme.blocks = new Blocks();
        theme.tabs = new Tabs();
        theme.gallery = new Gallery();
        theme.map = new Map();

        //Floorplan
        theme.pricelist = new Pricelist();
        theme.floorplan = new Floorplan();

        $( document.body ).addClass( 'loaded' );
    }
}

jQuery( document ).ready( function( $ ) {
    theme.init();
} );

console.timeLog("video");
